// extracted by mini-css-extract-plugin
module.exports = {"link":"FinderLink_link__3py6Z"};